import { Star } from "lucide-react";

import { cn } from "~/lib/cn";

/**
 * Five-star rating. Display-only by default; interactive when `onChange` is
 * provided.
 */
export function StarRating({
  value,
  onChange,
  size = "md",
  className,
}: {
  value: number;
  onChange?: (value: number) => void;
  size?: "sm" | "md" | "lg";
  className?: string;
}) {
  const sizeClass = { sm: "size-4", md: "size-5", lg: "size-7" }[size];

  return (
    <div
      className={cn("flex items-center gap-0.5", className)}
      role={onChange ? "radiogroup" : "img"}
      aria-label={`${value} out of 5 stars`}
    >
      {[1, 2, 3, 4, 5].map((star) =>
        onChange ? (
          <button
            key={star}
            type="button"
            role="radio"
            aria-checked={value === star}
            aria-label={`${star} star${star === 1 ? "" : "s"}`}
            className="rounded-sm transition-transform duration-200 hover:scale-110 focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
            onClick={() => onChange(star)}
          >
            <Star
              className={cn(
                sizeClass,
                star <= value
                  ? "fill-amber-400 text-amber-400"
                  : "text-gray-300",
              )}
            />
          </button>
        ) : (
          <Star
            key={star}
            className={cn(
              sizeClass,
              star <= value ? "fill-amber-400 text-amber-400" : "text-gray-300",
            )}
          />
        ),
      )}
    </div>
  );
}
